import Link from '../../views/TermofUse';
import { connect } from 'react-redux';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  locale: ownProps.match.params.locale,
  status: state.shift.status
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // console.log(value);
      window.close();
    }
  };
};

const TermofUse = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default TermofUse;



// WEBPACK FOOTER //
// ./src/components/container/TermofUse/index.js